import { combineReducers } from "@reduxjs/toolkit";
import baseReducer from "./base";
import doorConfigurationReducer from "./door_configuration_builder";
import pergolaConfigurationReducer from "./pergola_configuration_builder";

const reducers = combineReducers({
    base: baseReducer,
    doorConfigurationBuilder: doorConfigurationReducer,
    pergolaConfigurationBuilder: pergolaConfigurationReducer
});

export default reducers;